import { render, staticRenderFns } from "./FinanceStudent.vue?vue&type=template&id=f2ad8ef0"
import script from "./FinanceStudent.vue?vue&type=script&lang=js"
export * from "./FinanceStudent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports